<template>
  <div class="pointer-events-none fixed inset-x-0 bottom-20 z-[80] mx-auto w-full max-w-screen-sm pl-[112px] pr-4 transition-transform desk:hidden">
    <div class="pointer-events-auto flex min-h-[58px] w-full items-center overflow-hidden rounded-xl border border-gray-100 bg-white text-gray-900 shadow-[0_10px_28px_rgba(0,0,0,0.14)]">
      <p
        v-if="!hasItems"
        class="w-full px-4 py-3 text-center text-[13px] font-medium leading-5 text-gray-600"
        v-html="info.welcome"
      />
      <slot v-if="hasItems" />
    </div>
  </div>
</template>

<script>
import { ChatIcon } from "@vue-hero-icons/outline";
import { mapGetters } from "vuex";

export default {
  components: {
    ChatIcon,
  },
  computed: {
    ...mapGetters({
      hasItems: "cart/hasItems",
      info: "app/info",
    }),
  },
};
</script>

<style scoped>
.h-73px {
  height: 4.5625rem;
}
</style>
